// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#potential-establishments .establishment-list.empty,#potential-establishments .establishment-list .load-content{min-height:20em}", ""]);
// Exports
module.exports = exports;
